import $ from 'jquery';
import React from 'react';
import moment from 'moment';

import { Button, Icon, Form } from 'semantic-ui-react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import server from '../../functions/server';

export default class Edit extends React.Component {

    state = {
        id: 0,
        shift: 0,
        remarks: '',
        date: moment(new Date()).format('YYYY-MM-DD'),
        loading: false
    }

    componentDidUpdate() {
        let { event, id } = this.props;
        let { date } = this.state;
        if (date === event.start && this.state.id === id) return;
        this.setState({
            shift: event.shift,
            remarks: event.remarks,
            date: event.start,
            id,
            weekOffOrHoliday: event.weekOffOrHoliday
        });
    }

    editEvent = () => {
        let { id, shift, date, remarks, weekOffOrHoliday } = this.state;
        let context = this;
        let url = server() + '/employees/attendance/edit.php';
        let data = { id, shift, date, remarks, weekOffOrHoliday };
        $.ajax({
            url: url,
            data, type: 'POST',
            beforeSend: function (x) {
                context.setState({ load: true });
            }
        }).done((data) => {
            this.props.handleClose();
            this.props.getEvents();
        });
    }

    handleChange = (type) => (e, { value }) => {
        this.setState({
            [type]: value
        });
    }

    render() {
        let { open, handleClose } = this.props;
        let { shift, remarks, date, loading } = this.state;
        return (
            <Dialog fullWidth={true}
                maxWidth={"sm"}
                open={open} onClose={() => handleClose()} >
                <DialogTitle>{'Edit - ' + moment(date, 'YYYY-MM-DD').format('DD MMM YY')}</DialogTitle>
                <DialogContent>
                    <Form>
                        <Form.Group inline>
                            <Form.Radio
                                label='Holiday'
                                value={-1}
                                checked={shift < 0}
                                onChange={this.handleChange('shift')}
                            />
                            <Form.Radio
                                label='Present'
                                value={1}
                                checked={shift > 0}
                                onChange={this.handleChange('shift')}
                            />
                            <Form.Radio
                                label='Absent'
                                value={0}
                                checked={shift < 0.5 && shift >= 0}
                                onChange={this.handleChange('shift')}
                            />
                        </Form.Group>
                        <Form.Group inline>
                            <label>Shift</label>
                            <Form.Radio
                                label='0'
                                value={0}
                                checked={shift === 0}
                                onChange={this.handleChange('shift')}
                            />
                            <Form.Radio
                                label='0.5'
                                value={0.5}
                                checked={shift === 0.5}
                                onChange={this.handleChange('shift')}
                            />
                            <Form.Radio
                                label='1'
                                value={1}
                                checked={shift === 1}
                                onChange={this.handleChange('shift')}
                            />
                            <Form.Radio
                                label='1.5'
                                value={1.5}
                                checked={shift === 1.5}
                                onChange={this.handleChange('shift')}
                            />
                            <Form.Radio
                                label='2'
                                value={2}
                                checked={shift === 2}
                                onChange={this.handleChange('shift')}
                            />
                            <Form.Radio
                                label='2.5'
                                value={2.5}
                                checked={shift === 2.5}
                                onChange={this.handleChange('shift')}
                            />
                            
                            <Form.Radio
                                label='3'
                                value={3}
                                checked={shift === 3}
                                onChange={this.handleChange('shift')}
                            />
                        </Form.Group>
                        {
                            (this.state.shift === 1 && !this.state.weekOffOrHoliday) || this.state.shift == 0 ? null : (
                                <Form.TextArea
                                value={remarks}
                                onChange={this.handleChange('remarks')}
                                placeholder='Remarks...' />
                            )
                        }
                    </Form>
                </DialogContent>
                <DialogActions>
                    <Button color='red' onClick={() => handleClose()}>
                        <Icon name='remove' /> Cancel
                    </Button>
                    {!loading && <Button color='green' onClick={() => this.editEvent()}>
                        <Icon name='checkmark' /> Save
                    </Button>}
                    {loading && <Button color='green' loading>
                        Loading
                    </Button>}
                </DialogActions>
            </Dialog>
        );
    }

}